/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cdk-column-comments[_ngcontent-%COMP%]{text-align:center}table[_ngcontent-%COMP%]{width:100%}table[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]{vertical-align:middle}a[_ngcontent-%COMP%]{text-decoration:none;color:rgba(0,0,0,.87)}a[_ngcontent-%COMP%]:hover{text-decoration:underline;color:#3f51b5}.user-avatar[_ngcontent-%COMP%]{vertical-align:middle;margin-right:5px;height:30px;width:30px;border-radius:20px}tr.has-errors[_ngcontent-%COMP%]{background-color:#ffcdd2}\n/*# sourceMappingURL=build-health-report.component.css.map*/"];
export { styles as styles };
